import { memo } from 'react';
import {
  CurrencyLineChart,
  IntegerLineChart,
  PercentLineChart,
} from '../../../../../components/LineChart';
import { AllStatisticsData } from '../types';
import { ChartCard } from './chart-card';

const CHART_COLOR = '#365072';

interface StatisticsChartsProps {
  data: AllStatisticsData;
}

export const StatisticsCharts = memo(function StatisticsCharts({
  data,
}: StatisticsChartsProps) {
  return (
    <div className="flex flex-wrap gap-6">
      <ChartCard
        data={data.antecipacaoDia}
        title="Quantidade de Antecipações por Dia"
        yAxisLabel="Antecipações"
        color={CHART_COLOR}
        ChartComponent={IntegerLineChart}
      />

      <ChartCard
        data={data.totalAntecipadoDia}
        title="Total Antecipado no Dia"
        yAxisLabel="Valor Antecipado (R$)"
        color={CHART_COLOR}
        ChartComponent={CurrencyLineChart}
      />

      <ChartCard
        data={data.aderencia}
        title="Aderência dos Entregadores"
        yAxisLabel="Aderência (%)"
        color={CHART_COLOR}
        ChartComponent={PercentLineChart}
      />

      <ChartCard
        data={data.ticketMedioDia}
        title="Média Diária do Ticket"
        yAxisLabel="Ticket (R$)"
        color={CHART_COLOR}
        ChartComponent={CurrencyLineChart}
      />

      <ChartCard
        data={data.cadAprovadosDia}
        title="Quantidade Aprovados Dia"
        yAxisLabel="Entregadores Aprovados"
        color={CHART_COLOR}
        ChartComponent={IntegerLineChart}
      />
    </div>
  );
});
